import { useContext, useState } from 'react';

import AddImage from '../../reusable/images/add-image/add-image.component';
import Button from '../../reusable/button/button.component';
import ComponentModal from '../../reusable/component-modal/component-modal.component';
import AdminModal from '../../reusable/admin-modal/admin-modal.component';
import Spinner from '../../reusable/spinner/spinner.component';

import { ToastContext } from '../../../contexts/toast.context';

import { api } from "../../../config.js";
import Client from "../../../tools/client";

import {
    ButtonContainer,
    DeleteButton,
    ImagesContainer,
    Image,
    MainContainer
} from './category-images.styles';

const client = new Client();

const CategoryImages = ({ category, getCategory }) => {
    const [ loading, setLoading ] = useState(false);
    const [ showImage, setShowImage ] = useState(false);
    const [ showAddImage, setShowAddImage ] = useState(false);
    const [ showDeleteModal, setShowDeleteModal ] = useState(false);
    const [image, setImage] = useState('');
    const [cropData, setCropData] = useState(null);

    const { errorToast, successToast } = useContext(ToastContext);

    const addCategoryImage = async (file) => {
        if (!file) return;
        setLoading(true);

        const formData = new FormData();
        formData.append('files', file);
        formData.append('crop', JSON.stringify(cropData));
        formData.append('id', category.id);

        const res = await client.addCategoryImage(formData);

        if(res.status === 201) {
            successToast('Category Image Created Successfully');
            await getCategory();
            setImage('');
            setCropData(null);
            setShowAddImage(false);
            setShowImage(false);
        } else {
            errorToast('There was an error adding Category Image. Please try again.');
        }

        setLoading(false);
    };

    const handleDeleteThumbnail = async () => {
        setShowDeleteModal(false);
        await client.deleteCategoryThumbnail({ id: category.id });
        await getCategory();
        setShowImage(false);
    };

    const confirmDeleteThumbnail = () => {
        setShowDeleteModal(true);
    };

    return (
        <MainContainer>
            {loading ?
                <Spinner />
            :
                <>
                    <AdminModal 
                        show={showDeleteModal}
                        setShow={setShowDeleteModal}
                        title={'Delete Category Thumbnail'} 
                        image={category.thumbnailPath ? api + category.thumbnailPath : ''}
                        message={`Are you sure you want to permanently delete this image for ${category.name}?`} 
                        action={handleDeleteThumbnail} 
                        actionText={'Delete'}
                    />

                    <ComponentModal
                        isOpen={showImage}
                        onClose={() => setShowImage(false)}
                        title="Category Thumbnail"
                    >
                        <MainContainer>
                            <Image src={api + category.thumbnailPath} alt="thumbnail" width="300" height="300" />
                            <DeleteButton onClick={confirmDeleteThumbnail}>Delete Image</DeleteButton>
                        </MainContainer>
                    </ComponentModal>

                    <ComponentModal
                        isOpen={showAddImage}
                        onClose={() => setShowAddImage(false)}
                        title="Add Category Thumbnail"
                    >
                        <AddImage
                            image={image}
                            setImage={setImage}
                            saveImage={addCategoryImage}
                            showSaveButton={true}
                            setCropData={setCropData}
                        />
                    </ComponentModal>

                    <ImagesContainer>
                        {category.thumbnailPath ?
                            <Image onClick={() => setShowImage(true)} src={api + category.thumbnailPath} alt="thumbnail" width="200" height="200" />
                        :    
                            <Button onClick={() => setShowAddImage(true)}>Add Thumbnail</Button>
                        }
                    </ImagesContainer>
                </>
            }
        </MainContainer>
    );
};

export default CategoryImages;